export default "__VITE_ASSET__1f9e3a46__"